import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
  selector: 'app-click-to-copy',
  templateUrl: './click-to-copy.component.html',
  styleUrls: ['./click-to-copy.component.scss']
})
export class ClickToCopyComponent implements OnInit {
  @Input() public data:any;
  constructor(
    public uService:UtilityService
  ) { }

  ngOnInit(): void {
  }
 

}
